// Simple i18n for Health Buddy — primary: English & Telugu (with conversational slang)
// Secondary: Hindi, Tamil
export const LANGS = [
  { code: 'en', label: 'English',  short: 'EN', speech: 'en-IN' },
  { code: 'te', label: 'తెలుగు',  short: 'TE', speech: 'te-IN' },
  { code: 'hi', label: 'हिंदी',    short: 'HI', speech: 'hi-IN' },
  { code: 'ta', label: 'தமிழ்',   short: 'TA', speech: 'ta-IN' },
];

export const T = {
  en: {
    nav_home: 'Home', nav_chat: 'Talk to Buddy', nav_history: 'My Reports', nav_login: 'Login',
    nav_consultations: 'Consultations', nav_dashboard: 'Dashboard', nav_logout: 'Logout',
    hero_kicker: 'AI clinical intake assistant',
    hero_title: 'Tell Health Buddy what you feel. Get a doctor-ready summary.',
    hero_sub: 'Speak in your own language. Health Buddy asks safe intake questions and prepares a structured summary for a verified doctor to review.',
    hero_cta: 'Talk to Health Buddy',
    hero_cta_2: 'Use on WhatsApp',
    pick_lang: 'Pick your language',
    how_title: 'How it works',
    how_sub: 'Three simple steps. No medical words.',
    step1_t: 'Say Hi', step1_d: 'Open the chat or WhatsApp. Buddy greets you warmly.',
    step2_t: 'Tell Your Symptoms', step2_d: 'Speak or type — Buddy asks gentle questions, one at a time.',
    step3_t: 'Get Intake Summary', step3_d: 'A clear doctor-ready summary with symptoms, red flags, and review urgency. Download as PDF.',
    wa_title: 'Chat on WhatsApp, too',
    wa_sub: 'Same friendly Buddy — right inside WhatsApp. Save the number, send a quick hi.',
    wa_cta: 'Open WhatsApp',
    start_title: "Let's start your consultation",
    start_sub: 'Just a little about you. Buddy will take it from here.',
    name: 'Your name', age: 'Age', gender: 'Gender', phone: 'Phone number',
    male: 'Male', female: 'Female', other: 'Other',
    history: 'Any past illnesses or medicines? (optional)',
    start_btn: 'Start chatting with Buddy',
    type_here: 'Type your message…',
    voice_tap: 'Tap the mic to speak',
    listening: 'Listening…',
    thinking: 'Buddy is thinking…',
    generate_report: 'Finish & Prepare Summary',
    report_ready: 'Your intake summary is ready',
    download_pdf: 'Download PDF',
    back: 'Back',
    severity: 'Severity',
    summary: 'Summary',
    conditions: 'Doctor review points',
    red_flags: 'Urgent warnings',
    home_care: 'Safe comfort steps',
    otc: 'Medicine safety note',
    when_doc: 'When to see a doctor',
    lifestyle: 'Lifestyle advice',
    disclaimer: 'This is an intake summary for doctor review, not a final diagnosis or prescription.',
    my_reports: 'My Reports', enter_phone: 'Enter your phone number to view your reports', view: 'View',
    no_reports: 'No reports yet.',
    login: 'Login', register: 'Create account', email: 'Email', password: 'Password',
    user_login_title: 'User Login',
    user_login_sub: 'Login to view your dashboard and health records.',
    user_register_title: 'Create User Account',
    user_register_sub: 'Register to keep your records private to your login.',
    create_account: 'Create account',
    new_user: 'New user?',
    already_registered: 'Already registered?',
    invalid_credentials: 'Invalid credentials',
    could_not_register: 'Could not register',
    dashboard_title: 'My Dashboard',
    dashboard_sub: 'Your records and consultations in one place.',
    loading_dashboard: 'Loading dashboard…',
    active_consultation: 'Active Consultation',
    active_consultation_yes: 'You have an active consultation.',
    active_consultation_no: 'No active consultation.',
    resume_chat: 'Resume Chat',
    start_chat: 'Start Chat',
    latest_report: 'Latest Intake Summary',
    no_reports_yet: 'No reports yet.',
    open_report: 'Open Summary',
    doctor_consultations: 'Doctor Consultations',
    no_doctor_consultation: 'No doctor consultation yet.',
    latest_status: 'Latest status',
    view_consultations: 'View Consultations',
    fill_name_age_phone: 'Please fill name, age, and phone',
    could_not_start_session: 'Could not start session',
    buddy_could_not_reply: 'Buddy could not reply',
    voice_not_supported: 'Voice not supported in this browser',
    loading_active_session: 'Resuming your last session…',
    doctor_portal: 'Doctor Portal',
    doctor_portal_sub: 'Login to review patient referrals and respond.',
    doctor_enroll_title: 'Doctor Enrollment',
    doctor_enroll_sub: 'Create a doctor account for new onboarding.',
    full_name: 'Full name',
    specialty: 'Specialty',
    city: 'City',
    phone_optional: 'Phone (optional)',
    enroll_now: 'Enroll now',
    back_home: 'Back to home',
    doctor_pending: 'Pending',
    doctor_reviewed: 'Reviewed',
    doctor_closed: 'Closed',
    could_not_load_referrals: 'Could not load referrals',
    please_write_response: 'Please write a response',
    response_sent_patient: 'Response sent to patient',
    could_not_send_response: 'Could not send response',
    signed_pdf_uploaded: 'Signed PDF uploaded',
    upload_failed: 'Upload failed',
    pending_reviewed: 'Pending / Reviewed',
    patient_referrals: 'Patient Referrals',
    review_reports_guidance: 'Review the AI-generated intake summaries and respond with your clinical guidance.',
    loading: 'Loading…',
    no_referrals_yet: 'No referrals yet.',
    patient_note: 'Patient note',
    open_respond: 'Open & respond',
    referral: 'Referral',
    health_buddy_report: 'Health Buddy Intake Summary',
    likely_conditions: 'Doctor review points',
    red_flags_label: 'Red flags',
    download_ai_report_pdf: 'Download intake PDF',
    patient_message: "Patient's message",
    your_advice_diagnosis: 'Doctor response',
    write_clear_response: 'Write a clear, kind response for the patient…',
    prescription: 'Prescription',
    medicine: 'Medicine',
    dosage_placeholder: 'Dosage (e.g. 500mg 1-0-1)',
    duration_placeholder: 'Duration (5 days)',
    notes_placeholder: 'Notes (after food)',
    add_medicine: 'Add medicine',
    followup_optional: 'Follow-up date (optional)',
    signed_prescription_optional: 'Signed prescription PDF (optional)',
    view_uploaded: 'View uploaded',
    close: 'Close',
    send_to_patient: 'Send to patient',
    trust_1: 'Private', trust_2: 'In your language', trust_3: 'Doctor-quality report',
    checkup_start: 'Great, I will ask a few routine checkup questions to complete your health profile.',
    checkup_q1: 'Have you noticed any changes in your body lately?',
    checkup_q2: 'Do you take any medicines regularly? If yes, please describe.',
    checkup_q3: 'Do you have any allergies or past illnesses I should know about?',
    checkup_q4: 'How many hours do you sleep each night on average?',
    checkup_q5: 'Do you exercise regularly? If yes, what kind?',
    checkup_q6: 'Do you have an emergency contact name and phone number?',
    checkup_saved: 'Thanks, your checkup answers are saved. If you want, I can help you review your health profile.',
  },

  te: {
    nav_home: 'హోమ్', nav_chat: 'బడ్డీతో మాట్లాడు', nav_history: 'నా రిపోర్ట్‌లు', nav_login: 'లాగిన్',
    nav_consultations: 'కన్సల్టేషన్స్', nav_dashboard: 'డాష్‌బోర్డ్', nav_logout: 'లాగ్ అవుట్',
    hero_kicker: 'మీ సొంత AI హెల్త్ ఫ్రెండ్',
    hero_title: 'ఒంట్లో బాలేదా? హెల్త్ బడ్డీతో చెప్పేయండి — ఫ్రెండ్‌లా.',
    hero_sub: 'మీ భాషలో, మీ యాసలో మాట్లాడండి. ఏం ఇబ్బంది ఉందో చెప్పండి. కొన్ని నిమిషాల్లో డాక్టర్ స్థాయి రిపోర్ట్ ఇస్తాం. ఫ్రీ. ప్రైవేట్. WhatsApp లోనూ ఇక్కడే.',
    hero_cta: 'బడ్డీతో మాట్లాడండి',
    hero_cta_2: 'WhatsApp లో వాడండి',
    pick_lang: 'మీ భాష ఎంచుకోండి',
    how_title: 'ఎలా పని చేస్తుంది', how_sub: 'మూడు సింపుల్ స్టెప్స్. డాక్టర్ పదాలు లేవు.',
    step1_t: 'హాయ్ చెప్పండి', step1_d: 'చాట్ లేదా WhatsApp ఓపెన్ చేయండి. బడ్డీ ప్రేమగా పలకరిస్తాడు.',
    step2_t: 'మీ సమస్య చెప్పండి', step2_d: 'మాట్లాడొచ్చు, టైప్ కూడా చేయొచ్చు. బడ్డీ ఒక్కొక్క ప్రశ్న అడుగుతాడు.',
    step3_t: 'రిపోర్ట్ తీసుకోండి', step3_d: 'ఇంట్లో ఏం చేయాలో, ఎప్పుడు డాక్టర్ దగ్గరికి వెళ్ళాలో — అన్నీ ఒక చోట. PDF డౌన్‌లోడ్ చేసుకోండి.',
    wa_title: 'WhatsApp లోనూ మాట్లాడొచ్చు', wa_sub: 'అదే బడ్డీ — WhatsApp లో. నంబర్ సేవ్ చేసి హాయ్ పంపండి.', wa_cta: 'WhatsApp ఓపెన్ చేయండి',
    start_title: 'మీ కన్సల్టేషన్ మొదలెడదాం',
    start_sub: 'మీ గురించి కొంచెం చెప్పండి. ఆ తర్వాత బడ్డీ చూసుకుంటాడు.',
    name: 'మీ పేరు', age: 'వయసు', gender: 'లింగం', phone: 'ఫోన్ నంబర్',
    male: 'మగ', female: 'ఆడ', other: 'ఇతరం',
    history: 'ఇంతకు ముందు ఏదైనా జబ్బు లేదా మందులు ఉన్నాయా? (ఆప్షనల్)',
    start_btn: 'బడ్డీతో చాట్ మొదలెట్టండి',
    type_here: 'ఇక్కడ టైప్ చేయండి…', voice_tap: 'మాట్లాడాలంటే మైక్ నొక్కండి',
    listening: 'వింటున్నా…',
    thinking: 'బడ్డీ ఆలోచిస్తున్నాడు…',
    generate_report: 'ముగించి రిపోర్ట్ తీసుకోండి',
    report_ready: 'మీ హెల్త్ రిపోర్ట్ రెడీ',
    download_pdf: 'PDF డౌన్‌లోడ్',
    back: 'వెనక్కి',
    severity: 'తీవ్రత', summary: 'సారాంశం', conditions: 'ఉండే అవకాశమున్న జబ్బులు',
    red_flags: 'తక్షణం జాగ్రత్త కావాల్సినవి', home_care: 'ఇంట్లో జాగ్రత్తలు', otc: 'సాధారణ మందులు',
    when_doc: 'డాక్టర్‌ను ఎప్పుడు చూడాలి', lifestyle: 'జీవనశైలి సలహాలు',
    disclaimer: 'ఇది ఫైనల్ నిర్ధారణ కాదు. తీవ్ర సమస్యలు ఉంటే తప్పక డాక్టర్‌ను కలవండి.',
    my_reports: 'నా రిపోర్ట్‌లు', enter_phone: 'మీ ఫోన్ నంబర్ ఇవ్వండి, మీ రిపోర్ట్‌లు చూడండి', view: 'చూడండి',
    no_reports: 'ఇంకా రిపోర్ట్‌లు లేవు.',
    login: 'లాగిన్', register: 'ఖాతా క్రియేట్ చేయండి', email: 'ఇమెయిల్', password: 'పాస్‌వర్డ్',
    user_login_title: 'యూజర్ లాగిన్',
    user_login_sub: 'మీ డాష్‌బోర్డ్ మరియు రికార్డులు చూడటానికి లాగిన్ అవ్వండి.',
    user_register_title: 'యూజర్ ఖాతా సృష్టించండి',
    user_register_sub: 'మీ రికార్డులు మీ లాగిన్‌కే ప్రైవేట్‌గా ఉండేందుకు నమోదు చేయండి.',
    create_account: 'ఖాతా సృష్టించండి',
    new_user: 'కొత్త యూజరా?',
    already_registered: 'ఇప్పటికే నమోదు అయ్యారా?',
    invalid_credentials: 'తప్పు వివరాలు',
    could_not_register: 'నమోదు కాలేదు',
    dashboard_title: 'నా డాష్‌బోర్డ్',
    dashboard_sub: 'మీ రికార్డులు, కన్సల్టేషన్స్ ఒకే చోట.',
    loading_dashboard: 'డాష్‌బోర్డ్ లోడ్ అవుతోంది…',
    active_consultation: 'యాక్టివ్ కన్సల్టేషన్',
    active_consultation_yes: 'మీకు యాక్టివ్ కన్సల్టేషన్ ఉంది.',
    active_consultation_no: 'యాక్టివ్ కన్సల్టేషన్ లేదు.',
    resume_chat: 'చాట్ కొనసాగించు',
    start_chat: 'చాట్ ప్రారంభించు',
    latest_report: 'తాజా రిపోర్ట్',
    no_reports_yet: 'ఇంకా రిపోర్ట్‌లు లేవు.',
    open_report: 'రిపోర్ట్ తెరువు',
    doctor_consultations: 'డాక్టర్ కన్సల్టేషన్స్',
    no_doctor_consultation: 'ఇంకా డాక్టర్ కన్సల్టేషన్ లేదు.',
    latest_status: 'తాజా స్థితి',
    view_consultations: 'కన్సల్టేషన్స్ చూడండి',
    fill_name_age_phone: 'పేరు, వయసు, ఫోన్ నంబర్ తప్పనిసరి',
    could_not_start_session: 'సెషన్ ప్రారంభించలేకపోయాం',
    buddy_could_not_reply: 'బడ్డీ స్పందించలేకపోయాడు',
    voice_not_supported: 'ఈ బ్రౌజర్‌లో వాయిస్ సపోర్ట్ లేదు',
    loading_active_session: 'మీ చివరి సెషన్ తెరుస్తున్నాం…',
    doctor_portal: 'డాక్టర్ పోర్టల్',
    doctor_portal_sub: 'పేషెంట్ రిఫరల్స్ చూసి స్పందించడానికి లాగిన్ అవ్వండి.',
    doctor_enroll_title: 'డాక్టర్ నమోదు',
    doctor_enroll_sub: 'కొత్త డాక్టర్ ఖాతా సృష్టించండి.',
    full_name: 'పూర్తి పేరు',
    specialty: 'స్పెషాలిటీ',
    city: 'నగరం',
    phone_optional: 'ఫోన్ (ఐచ్ఛికం)',
    enroll_now: 'ఇప్పుడే నమోదు',
    back_home: 'హోమ్‌కు వెనక్కి',
    trust_1: 'ప్రైవేట్', trust_2: 'మీ భాషలో', trust_3: 'డాక్టర్ స్థాయి రిపోర్ట్',
    checkup_start: 'సరే, మీ హెల్త్ ప్రొఫైల్ పూర్తిచేయడానికి కొన్ని రూటీన్ చెక్‌అప్ ప్రశ్నలు అడుగుతాను.',
    checkup_q1: 'మీ శరీరంలో ఏదైనా మార్పులు గమనించారా?',
    checkup_q2: 'మీరు క్రమం గా ఏ మందులు తీసుకుంటారు? ఉంటే వివరించండి.',
    checkup_q3: 'మీకు ఏదైనా అలర్జీ లేదా గతంలో జబ్బులు ఉన్నాయా?',
    checkup_q4: 'ఆ రాత్రిపూట సగటున ఎన్ని గంటలు నిద్ర పోతారు?',
    checkup_q5: 'మీరు క్రమం గా వ్యాయామం చేస్తారా? ఉంటే ఏ రకమైన?',
    checkup_q6: 'మీకు ఎమర్జెన్సీ కాంటాక్ట్ పేరు మరియు ఫోన్ నంబర్ ఉన్నాయా?',
    checkup_saved: 'థాంక్‌స్, మీ చెక్‌అప్ సమాధానలు సేవ్ చేయబడ్డాయి. మీ హెల్త్ ప్రొఫైల్ రిలీవ్ చేయడానికి సాయ్యం చేయాలనుకుంటున్నాయా?',
  },

  hi: {
    nav_home: 'होम', nav_chat: 'बडी से बात', nav_history: 'मेरी रिपोर्ट', nav_login: 'लॉगिन',
    nav_consultations: 'कंसल्टेशन', nav_dashboard: 'डैशबोर्ड', nav_logout: 'लॉगआउट',
    hero_kicker: 'आपका अपना AI स्वास्थ्य साथी',
    hero_title: 'तबीयत ठीक नहीं? हेल्थ बडी से कहें — दोस्त की तरह।',
    hero_sub: 'अपनी भाषा में बात करें। लक्षण बताएँ। कुछ मिनटों में डॉक्टर-जैसी रिपोर्ट पाएँ। मुफ्त। निजी।',
    hero_cta: 'हेल्थ बडी से बात करें',
    hero_cta_2: 'WhatsApp पर बात करें',
    pick_lang: 'अपनी भाषा चुनें',
    how_title: 'यह कैसे काम करता है', how_sub: 'तीन आसान कदम।',
    step1_t: 'नमस्ते कहें', step1_d: 'चैट या WhatsApp खोलें। बडी आपका स्वागत करेगा।',
    step2_t: 'लक्षण बताएँ', step2_d: 'बोलें या लिखें। बडी आराम से सवाल पूछेगा।',
    step3_t: 'रिपोर्ट पाएँ', step3_d: 'साफ़ रिपोर्ट। घर की देखभाल, चेतावनी, कब डॉक्टर को दिखाएँ। PDF।',
    wa_title: 'WhatsApp पर भी', wa_sub: 'वही प्यारा बडी — सीधे WhatsApp में।', wa_cta: 'WhatsApp खोलें',
    start_title: 'चलिए आपकी जांच शुरू करते हैं',
    start_sub: 'अपने बारे में थोड़ा बताएँ।',
    name: 'आपका नाम', age: 'उम्र', gender: 'लिंग', phone: 'मोबाइल नंबर',
    male: 'पुरुष', female: 'महिला', other: 'अन्य',
    history: 'पुरानी बीमारी? (वैकल्पिक)',
    start_btn: 'बडी से चैट शुरू करें',
    type_here: 'यहाँ लिखें…', voice_tap: 'बोलने के लिए माइक दबाएँ',
    listening: 'सुन रहा हूँ…', thinking: 'बडी सोच रहा है…',
    generate_report: 'रिपोर्ट तैयार करें',
    report_ready: 'आपकी हेल्थ रिपोर्ट तैयार है',
    download_pdf: 'PDF डाउनलोड करें', back: 'वापस',
    severity: 'गंभीरता', summary: 'सारांश', conditions: 'संभावित रोग',
    red_flags: 'ज़रूरी चेतावनी', home_care: 'घर की देखभाल', otc: 'साधारण दवाएँ',
    when_doc: 'डॉक्टर कब दिखाएँ', lifestyle: 'जीवनशैली सलाह',
    disclaimer: 'यह अंतिम निदान नहीं है। गंभीर स्थिति में डॉक्टर से मिलें।',
    my_reports: 'मेरी रिपोर्ट', enter_phone: 'फ़ोन नंबर डालें', view: 'देखें',
    no_reports: 'कोई रिपोर्ट नहीं।',
    login: 'लॉगिन', register: 'खाता बनाएँ', email: 'ईमेल', password: 'पासवर्ड',
    user_login_title: 'यूज़र लॉगिन',
    user_login_sub: 'डैशबोर्ड और रिकॉर्ड देखने के लिए लॉगिन करें।',
    user_register_title: 'यूज़र अकाउंट बनाएं',
    user_register_sub: 'रिकॉर्ड्स को निजी रखने के लिए रजिस्टर करें।',
    create_account: 'खाता बनाएं',
    new_user: 'नए यूज़र?',
    already_registered: 'पहले से रजिस्टर्ड?',
    invalid_credentials: 'गलत क्रेडेंशियल्स',
    could_not_register: 'रजिस्टर नहीं हो पाया',
    dashboard_title: 'मेरा डैशबोर्ड',
    dashboard_sub: 'आपके रिकॉर्ड और कंसल्टेशन एक जगह।',
    loading_dashboard: 'डैशबोर्ड लोड हो रहा है…',
    active_consultation: 'सक्रिय कंसल्टेशन',
    active_consultation_yes: 'आपका एक सक्रिय कंसल्टेशन है।',
    active_consultation_no: 'कोई सक्रिय कंसल्टेशन नहीं।',
    resume_chat: 'चैट जारी रखें',
    start_chat: 'चैट शुरू करें',
    latest_report: 'ताज़ा रिपोर्ट',
    no_reports_yet: 'अभी कोई रिपोर्ट नहीं।',
    open_report: 'रिपोर्ट खोलें',
    doctor_consultations: 'डॉक्टर कंसल्टेशन',
    no_doctor_consultation: 'अभी कोई डॉक्टर कंसल्टेशन नहीं।',
    latest_status: 'ताज़ा स्थिति',
    view_consultations: 'कंसल्टेशन देखें',
    fill_name_age_phone: 'कृपया नाम, उम्र और फोन भरें',
    could_not_start_session: 'सेशन शुरू नहीं हो सका',
    buddy_could_not_reply: 'बडी जवाब नहीं दे सका',
    voice_not_supported: 'इस ब्राउज़र में वॉइस सपोर्ट नहीं है',
    loading_active_session: 'पिछला सेशन खोला जा रहा है…',
    doctor_portal: 'डॉक्टर पोर्टल',
    doctor_portal_sub: 'रिफरल्स देखें और रोगी को जवाब दें।',
    doctor_enroll_title: 'डॉक्टर पंजीकरण',
    doctor_enroll_sub: 'नए डॉक्टर अकाउंट के लिए पंजीकरण करें।',
    full_name: 'पूरा नाम',
    specialty: 'विशेषज्ञता',
    city: 'शहर',
    phone_optional: 'फोन (वैकल्पिक)',
    enroll_now: 'अभी पंजीकरण करें',
    back_home: 'होम पर वापस जाएँ',
    trust_1: 'निजी', trust_2: 'आपकी भाषा में', trust_3: 'डॉक्टर-जैसी रिपोर्ट',
    checkup_start: 'अच्छा, मैं आपका स्वास्थ्य प्रोफ़ाइल पूरा करने के लिए कुछ नियमित चेकअप प्रश्न पूछूंगा।',
    checkup_q1: 'क्या आपने अपने शरीर में कोई बदलाव देखे हैं?',
    checkup_q2: 'क्या आप नियमित रूप से कोई दवाई लेते हैं? हाँ तो बताएँ।',
    checkup_q3: 'क्या आपको कोई एलर्जी या पुरानी बीमारी है?',
    checkup_q4: 'आप रात में औसतन कितने घंटे सोते हैं?',
    checkup_q5: 'क्या आप नियमित व्यायाम करते हैं? हाँ तो कौन सा?',
    checkup_q6: 'क्या आपके पास इमरजेंसी का नाम और नंबर है?',
    checkup_saved: 'धन्यवाद, आपके चेकअप के उत्तर सहेजे गए हैं। क्या आप अपने स्वास्थ्य प्रोफ़ाइल की समीक्षा करना चाहते हैं?',
  },

  ta: {
    nav_home: 'முகப்பு', nav_chat: 'பட்டியிடம் பேசு', nav_history: 'என் அறிக்கைகள்', nav_login: 'உள்நுழை',
    nav_consultations: 'ஆலோசனைகள்', nav_dashboard: 'டாஷ்போர்டு', nav_logout: 'வெளியேறு',
    hero_kicker: 'உங்கள் அன்பான AI சுகாதார தோழன்',
    hero_title: 'உடல்நிலை சரியில்லையா? ஹெல்த் பட்டியிடம் சொல்லுங்கள் — நண்பனைப் போல.',
    hero_sub: 'உங்கள் மொழியில் பேசுங்கள். அறிகுறிகளை சொல்லுங்கள். சில நிமிடங்களில் டாக்டர் தர அறிக்கை. இலவசம்.',
    hero_cta: 'ஹெல்த் பட்டியிடம் பேசு',
    hero_cta_2: 'WhatsApp-இல் பயன்படுத்து',
    pick_lang: 'உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்',
    how_title: 'எப்படி வேலை செய்கிறது', how_sub: 'மூன்று எளிய படிகள்.',
    step1_t: 'வணக்கம் சொல்', step1_d: 'சாட் அல்லது WhatsApp திறக்கவும்.',
    step2_t: 'அறிகுறிகளை சொல்', step2_d: 'பேசலாம் அல்லது தட்டச்சலாம்.',
    step3_t: 'அறிக்கை பெறு', step3_d: 'தெளிவான அறிக்கை. PDF பதிவிறக்கம்.',
    wa_title: 'WhatsApp-இலும்', wa_sub: 'அதே பட்டி — WhatsApp-இல்.', wa_cta: 'WhatsApp திற',
    start_title: 'ஆலோசனையை தொடங்குவோம்',
    start_sub: 'உங்களைப் பற்றி கொஞ்சம் சொல்லுங்கள்.',
    name: 'உங்கள் பெயர்', age: 'வயது', gender: 'பாலினம்', phone: 'தொலைபேசி எண்',
    male: 'ஆண்', female: 'பெண்', other: 'மற்றவை',
    history: 'முந்தைய நோய்கள்? (விருப்பம்)',
    start_btn: 'பட்டியுடன் சாட் தொடங்கு',
    type_here: 'இங்கே தட்டச்சு செய்யவும்…', voice_tap: 'பேச மைக் அழுத்தவும்',
    listening: 'கேட்கிறேன்…', thinking: 'பட்டி யோசிக்கிறான்…',
    generate_report: 'அறிக்கை உருவாக்கு',
    report_ready: 'உங்கள் அறிக்கை தயார்',
    download_pdf: 'PDF பதிவிறக்கு', back: 'பின்னால்',
    severity: 'தீவிரம்', summary: 'சுருக்கம்', conditions: 'சாத்தியமான நோய்கள்',
    red_flags: 'அவசர எச்சரிக்கைகள்', home_care: 'வீட்டு பராமரிப்பு', otc: 'சாதாரண மருந்துகள்',
    when_doc: 'எப்போது டாக்டரை பார்க்க', lifestyle: 'வாழ்க்கை முறை ஆலோசனை',
    disclaimer: 'இது இறுதி நோயறிதல் அல்ல. கடுமையான நிலையில் டாக்டரை பாருங்கள்.',
    my_reports: 'என் அறிக்கைகள்', enter_phone: 'தொலைபேசி எண் உள்ளிடவும்', view: 'பார்',
    no_reports: 'அறிக்கைகள் இல்லை.',
    login: 'உள்நுழை', register: 'கணக்கை உருவாக்கு', email: 'மின்னஞ்சல்', password: 'கடவுச்சொல்',
    user_login_title: 'பயனர் உள்நுழைவு',
    user_login_sub: 'உங்கள் டாஷ்போர்டு மற்றும் பதிவுகளை பார்க்க உள்நுழையவும்.',
    user_register_title: 'பயனர் கணக்கு உருவாக்கவும்',
    user_register_sub: 'உங்கள் பதிவுகள் தனிப்பட்டதாக இருக்க பதிவு செய்யவும்.',
    create_account: 'கணக்கு உருவாக்கு',
    new_user: 'புதிய பயனரா?',
    already_registered: 'ஏற்கனவே பதிவு செய்தீர்களா?',
    invalid_credentials: 'தவறான விவரங்கள்',
    could_not_register: 'பதிவு செய்ய முடியவில்லை',
    dashboard_title: 'என் டாஷ்போர்டு',
    dashboard_sub: 'உங்கள் பதிவுகள் மற்றும் ஆலோசனைகள் ஒரே இடத்தில்.',
    loading_dashboard: 'டாஷ்போர்டு ஏற்றப்படுகிறது…',
    active_consultation: 'செயலில் உள்ள ஆலோசனை',
    active_consultation_yes: 'உங்களுக்கு செயலில் உள்ள ஆலோசனை உள்ளது.',
    active_consultation_no: 'செயலில் ஆலோசனை இல்லை.',
    resume_chat: 'அரட்டை தொடரவும்',
    start_chat: 'அரட்டை தொடங்கு',
    latest_report: 'சமீபத்திய அறிக்கை',
    no_reports_yet: 'இன்னும் அறிக்கைகள் இல்லை.',
    open_report: 'அறிக்கை திற',
    doctor_consultations: 'மருத்துவர் ஆலோசனைகள்',
    no_doctor_consultation: 'இன்னும் மருத்துவர் ஆலோசனை இல்லை.',
    latest_status: 'சமீப நிலை',
    view_consultations: 'ஆலோசனைகள் பார்க்க',
    fill_name_age_phone: 'பெயர், வயது, தொலைபேசி நிரப்பவும்',
    could_not_start_session: 'அமர்வு தொடங்க முடியவில்லை',
    buddy_could_not_reply: 'பட்டி பதிலளிக்க முடியவில்லை',
    voice_not_supported: 'இந்த உலாவியில் குரல் ஆதரவு இல்லை',
    loading_active_session: 'முந்தைய அமர்வு மீண்டும் திறக்கப்படுகிறது…',
    doctor_portal: 'மருத்துவர் போர்டல்',
    doctor_portal_sub: 'பரிந்துரைகளை பார்க்கவும் நோயாளிக்கு பதில் அளிக்கவும்.',
    doctor_enroll_title: 'மருத்துவர் பதிவு',
    doctor_enroll_sub: 'புதிய மருத்துவர் கணக்கு உருவாக்கவும்.',
    full_name: 'முழுப்பெயர்',
    specialty: 'சிறப்பு துறை',
    city: 'நகரம்',
    phone_optional: 'தொலைபேசி (விருப்பம்)',
    enroll_now: 'இப்போது பதிவு செய்',
    back_home: 'முகப்பிற்கு திரும்பு',
    trust_1: 'தனிப்பட்ட', trust_2: 'உங்கள் மொழியில்', trust_3: 'டாக்டர் தர அறிக்கை',
  },
};

export const t = (lang, key) => (T[lang] && T[lang][key]) || T.en[key] || key;
